import { useState } from "react";

type InputProps = {
  label?: string;
  value: string;
  editable: boolean;
  className?: string;
};

const InputField = ({ label, value, editable, className = "" }: InputProps) => (
  <div className={` flex justify-between items-center space-y-4 ${className}`}>
    {label && (
      <label className="w-full text-base  text-[#212121]">{label}</label>
    )}
    <input
      type="text"
      value={value}
      disabled={!editable}
      className={`px-4 py-2 text-sm w-full rounded-full outline-none ${
        editable
          ? " bg-white border border-[#D8D8D8]"
          : "bg-[#F2F2F2] border-transparent text-gray-700"
      }`}
    />
  </div>
);

export default function Password() {
  const [isEdit, setIsEdit] = useState(false);

  return (
    <div className=" w-[47rem] mx-auto text-[#1E293B] space-y-8 py-4 ">
      <div className="flex justify-between items-center">
        <p className="text-xs font-semibold text-[#212121]/70">PASSWORD</p>
        <button
          onClick={() => setIsEdit(!isEdit)}
          className="bg-[#FBD037] text-[#212121] text-sm font-semibold px-5 py-1.5 rounded-full"
        >
          {isEdit ? "Save" : "Edit"}
        </button>
      </div>
      <div className="divide-y divide-[#212121]/20 space-y-2">
        <InputField
          label="Current Password"
          value="gwarm@123"
          editable={isEdit}
        />
        <InputField label="New Password" value="gwarm@1234" editable={isEdit} />
        <InputField
          label="Confirm New Password"
          value="gwarm@1234"
          editable={isEdit}
        />
        <div className="pt-3">
          <p className="text-sm  px-2 text-[#212121]  border-l-4 border-[#FBD037]">
            <b>Note</b> : 8 characters minimum: One number: One uppercase
            character: One lowercase character
          </p>
        </div>
      </div>
    </div>
  );
}
